import { PLACEHOLDER } from 'components/column-renderers'
import { CSVField } from 'hooks/useExportCSV'
import { TraineeStatus, TraineeStatusLabels } from 'types'

const statusField: CSVField = {
  label: 'User Status',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: ({ userStatus }: any) => {
    if (!userStatus) {
      return PLACEHOLDER
    }

    const normalized = String(userStatus).toUpperCase() as TraineeStatus
    return TraineeStatusLabels[normalized] || String(userStatus)
  },
}

export const orgTraineeCSVFields: CSVField[] = [
  { label: 'First Name', value: 'firstname' },
  { label: 'Last Name', value: 'lastname' },
  { label: 'Email', value: 'email' },
  { label: 'Mobile Phone', value: 'phoneNumber' },
  { label: 'Total Time Online', value: 'totalEngagement' },
  statusField,
  { label: 'Institutional Access Code', value: 'accessCodeCode' },
  { label: 'Organization', value: 'organizationName' },
  { label: 'Pathway', value: 'trainingPathwayTypeTitle' },
  { label: 'Access Code Effective Date', value: 'accessCodeEffectiveDate' },
  { label: 'Access Code Expire Date', value: 'accessCodeExpiryDate' },
]
